import * as React from 'react';
import { FormatSection, InsertMenu } from './components/Menus';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorStateHook } from '../../BaseEditor/hooks/useBaseEditorFormatState';

interface CommentToolbarPluginProps {
  setIsLinkEditMode: (isEdit: boolean) => void;
  editorState: EditorStateHook;
}

export default function CommentToolbarPlugin({
  setIsLinkEditMode,
  editorState
}: CommentToolbarPluginProps): JSX.Element {
  const [editor] = useLexicalComposerContext();

  const handleLinkClick = () => {
    editorState.toggleLink();
    setIsLinkEditMode(!editorState.isLink);
  };

  return (
    <div className="flex items-center">
      <FormatSection
        activeEditor={editor}
        isBold={editorState.isBold}
        isItalic={editorState.isItalic}
        isUnderline={editorState.isUnderline}
        isCode={editorState.isCode}
        isLink={editorState.isLink}
        onBoldClick={editorState.toggleBold}
        onItalicClick={editorState.toggleItalic}
        onUnderlineClick={editorState.toggleUnderline}
        onCodeClick={editorState.toggleCode}
        onLinkClick={handleLinkClick}
      />

      {/* <TextStyleMenu
        activeEditor={editor}
        formatHeading={handleFormatHeading}
        formatList={handleFormatList}
        formatParagraph={editorState.formatParagraph}
        formatQuote={editorState.formatQuote}
      /> */}

      {/* Media buttons */}
      {/* <Tooltip label="Insert Image">
        <ToolbarButton aria-label="Insert image" onClick={handleInsertImage}>
          <img className="h-[24px] w-[24px]" src={ImageIcon} alt="File" />
        </ToolbarButton>
      </Tooltip>

      <Tooltip label="Insert GIF">
        <ToolbarButton aria-label="Insert GIF" onClick={handleInsertGif}>
          <img className="h-[24px] w-[24px]" src={GifIcon} alt="Gif" />
        </ToolbarButton>
      </Tooltip> */}

      <InsertMenu editor={editor} editorState={editorState} setIsLinkEditMode={setIsLinkEditMode} />
    </div>
  );
}
